import { render, staticRenderFns } from "./recruit-link-list.vue?vue&type=template&id=210f57ae&scoped=true"
import script from "./recruit-link-list.vue?vue&type=script&lang=js"
export * from "./recruit-link-list.vue?vue&type=script&lang=js"
import style0 from "./recruit-link-list.vue?vue&type=style&index=0&id=210f57ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210f57ae",
  null
  
)

export default component.exports